import React from "react";
import { useField } from "formik";

// Labelled text field of the order flows, bound to Formik
function FlowField({ name, label, optional = false, hint, ...inputProps }) {
  const [field, meta] = useField(name);
  const hasError = Boolean(meta.touched && meta.error);
  const id = `field-${name}`;

  return (
    <div className="flow-field">
      {label && (
        <label htmlFor={id} className="flow-label">
          {label} {optional && <small>(facultatif)</small>}
        </label>
      )}
      <input
        id={id}
        className={`flow-input ${hasError ? "is-invalid" : ""}`}
        aria-invalid={hasError}
        {...field}
        value={field.value ?? ""}
        {...inputProps}
      />
      {hasError ? (
        <p className="flow-error">{meta.error}</p>
      ) : (
        hint && <p className="flow-hint">{hint}</p>
      )}
    </div>
  );
}

export default FlowField;
